// @TODO this is a placeholder
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';

import CardsGridWrapper from '../../../CardsGridWrapper';
import CardImage from '../../../CardImage';
import CardContent from '../../../CardContent';
import CardElement from '../../../CardElement';

const generateCardContentClassNames = ({ hasImage }) => classNames(
  'card__content',
  'flex-container',
  'card__content--individual',
  {
    'card__content--individual-with-image': hasImage,
  },
);

const generateCardContentBoxClassNames = ({ contentBoxTheme }) => classNames(
  'card__content-box',
  'flex-dir-column',
  'flex-container',
  'align-center-middle',
  'xsmall-text--center',
  {
    'card__content-box--individual-solid': contentBoxTheme === 'solid',
    'card__content-box--individual-alpha': contentBoxTheme === 'alpha',
    'card__content-box--individual-transparent': contentBoxTheme === 'transparent',
  },
);

const CardsIndividualVerticalQuarter = ({
  fullWidth = false,
  contentBoxTheme = 'solid',
  isTitleUnderlined = true,
  headingLevel,
  tagHeadingLevel,
  isTagUnderlined = false,
  showStarRating = false,
  cardsData,
  cover,
  zoomOnHover,
  fixedHeight,
  hideDescription,
  openLinkInNewTab = false,
  fullClickableArea = true,
  renderCustomRating,
}) => (
  <CardsGridWrapper fullWidth={fullWidth}>
    {Array.isArray(cardsData) && (
      cardsData.map(card => (
        <div key={R.prop('id')(card)} className="card cell xsmall-8 medium-4 card--individual">
          <CardElement
            linkUrl={R.path(['link', 'url'])(card)}
            linkText={R.path(['link', 'text'])(card)}
            accessibleLinkText={R.path(['link', 'accessibleText'])(card)}
            openLinkInNewTab={openLinkInNewTab}
            fullClickableArea={fullClickableArea}
          >
            {R.prop('imageSrc')(card) && (
              <CardImage
                src={R.prop('imageSrc')(card)}
                srcset={R.prop('imageSrcSet')(card)}
                alt={R.prop('alt')(card)}
                cover={cover}
                zoomOnHover={zoomOnHover}
                fixedHeight={fixedHeight}
              />
            )}

            {(R.prop('title')(card) || R.prop('description')(card)) && (
              <CardContent
                title={R.prop('title')(card)}
                description={R.prop('description')(card)}
                linkUrl={R.path(['link', 'url'])(card)}
                linkText={R.path(['link', 'text'])(card)}
                tag={R.prop('tag')(card)}
                tagHeadingLevel={tagHeadingLevel}
                isTagUnderlined={isTagUnderlined}
                showStarRating={showStarRating}
                headingLevel={headingLevel}
                isTitleUnderlined={isTitleUnderlined}
                cardContentClassNames={generateCardContentClassNames({ hasImage: R.prop('imageSrc')(card) })}
                cardContentBoxClassNames={generateCardContentBoxClassNames({ contentBoxTheme })}
                hideDescription={hideDescription}
                openLinkInNewTab={openLinkInNewTab}
                fullClickableArea={fullClickableArea}
                renderCustomRating={renderCustomRating}
              />
            )}
          </CardElement>
        </div>
      ))
    )}
  </CardsGridWrapper>
);

CardsIndividualVerticalQuarter.propTypes = {
  fullWidth: PropTypes.bool,
  contentBoxTheme: PropTypes.oneOf(['solid', 'alpha', 'transparent']),
  headingLevel: PropTypes.number,
  isTitleUnderlined: PropTypes.bool,
  tagHeadingLevel: PropTypes.number,
  isTagUnderlined: PropTypes.bool,
  showStarRating: PropTypes.bool,
  cardsData: PropTypes.arrayOf(PropTypes.shape({
    tag: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
    }),
  })),
  cover: PropTypes.bool,
  zoomOnHover: PropTypes.bool,
  fixedHeight: PropTypes.bool,
  hideDescription: PropTypes.bool,
  openLinkInNewTab: PropTypes.bool,
  fullClickableArea: PropTypes.bool,
  renderCustomRating: PropTypes.func,
};

export default CardsIndividualVerticalQuarter;
